/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';

/**
 * A command used to add a new channelItem in a document. Source for the new
 * channelItem must be provided.  This source will be converted to an AAI
 * channelItem object and then added to the data model.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class AddChannelItemCommand extends AbstractCommand {
    public _channelItemExists : boolean;

    public _emptyChannelItems : boolean;

    public _newChannelItemName : string;

    public _newChannelItemObj : any;

    public constructor(channelItemName? : any, from? : any) {
        if(((typeof channelItemName === 'string') || channelItemName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super();
            if(this._channelItemExists===undefined) this._channelItemExists = false;
            if(this._emptyChannelItems===undefined) this._emptyChannelItems = false;
            if(this._newChannelItemName===undefined) this._newChannelItemName = null;
            if(this._newChannelItemObj===undefined) this._newChannelItemObj = null;
            if(this._channelItemExists===undefined) this._channelItemExists = false;
            if(this._emptyChannelItems===undefined) this._emptyChannelItems = false;
            if(this._newChannelItemName===undefined) this._newChannelItemName = null;
            if(this._newChannelItemObj===undefined) this._newChannelItemObj = null;
            (() => {
                this._newChannelItemName = channelItemName;
                this._newChannelItemObj = from;
            })();
        } else if(channelItemName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._channelItemExists===undefined) this._channelItemExists = false;
            if(this._emptyChannelItems===undefined) this._emptyChannelItems = false;
            if(this._newChannelItemName===undefined) this._newChannelItemName = null;
            if(this._newChannelItemObj===undefined) this._newChannelItemObj = null;
            if(this._channelItemExists===undefined) this._channelItemExists = false;
            if(this._emptyChannelItems===undefined) this._emptyChannelItems = false;
            if(this._newChannelItemName===undefined) this._newChannelItemName = null;
            if(this._newChannelItemObj===undefined) this._newChannelItemObj = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddChannelItemCommand] Executing.");
        let doc : AaiDocument = <AaiDocument>document;
        if(doc.channels != null && /* isEmpty */(Object.keys(doc.channels).length == 0)) {
            this._emptyChannelItems = true;
        }
        if(!this.isNullOrUndefined(/* get */((m,k) => m[k]===undefined?null:m[k])(doc.channels, this._newChannelItemName))) {
            LoggerCompat.info("[AddChannelItemCommand] AddChannelItemCommand with name %s already exists.", this._newChannelItemName);
            this._channelItemExists = true;
        } else {
            let channelItem : AaiChannelItem = doc.createChannelItem(this._newChannelItemName);
            doc.addChannelItem(channelItem);
            Library.readNode(this._newChannelItemObj, channelItem);
            this._channelItemExists = false;
        }
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddChannelItemCommand] Reverting.");
        if(this._channelItemExists) {
            return;
        }
        let doc : AaiDocument = <AaiDocument>document;
        if(this._emptyChannelItems) {
            /* clear */(obj => { for (let member in obj) delete obj[member]; })(doc.channels);
        } else {
            /* remove */(map => { let deleted = doc.channels[this._newChannelItemName];delete doc.channels[this._newChannelItemName];return deleted;})(doc.channels);
        }
    }
}
AddChannelItemCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AddChannelItemCommand";
AddChannelItemCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




